import React, { useEffect } from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { connectRolesVM, RolesContext } from './roles.context';
import { RolesVM } from './roles.viewmodel';
import RolesList from './_roles-list/roles-list';

interface IProps {
    vm: RolesVM;
}

const RolesContainer = ({ vm }: IProps) => {
    useEffect(() => {
        return () => {
            vm.willUnmount();
        };
    });

    return <RolesList vm={vm} />;
};

const RolesConnected = connectRolesVM<IProps>(RolesContainer, vm => ({ vm: vm }));

export const Roles = moduleHost(RolesVM, RolesContext, RolesConnected);
